import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Typography, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function Hero() {
  const theme = useTheme();
  
  return (
    <Box id="hero">
      <Container
        sx={{
          marginTop: theme.spacing(3.75), // 30px
          marginBottom: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1, width: { xs: '100%', md: 'auto' } }}>
            <Typography
              variant="h1"
              sx={{
                marginBottom: theme.spacing(2),
              }}
            >
              <Box component="div">Simplicity</Box>
              <Box component="div">Privacy</Box>
              <Box component="div">User-Friendly</Box>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                marginBottom: theme.spacing(2.5), // 2rem
                width: { xs: '100%', md: '80%' },
              }}
            >
              A minimalist, no data collected, completely free, user-friendly locally stored note-taking platform designed with privacy at its core. Effortlessly create, edit, and organize notes in real time, with data encrypted and securely stored to ensure your thoughts remain yours. 
            </Typography> 
            <Box>
              <Button
                variant="contained"
                color="primary"
                size="large"
                href="/dashboard"
                sx={{
                  marginRight: theme.spacing(2),
                }}
                endIcon={<ArrowForwardIcon />}
              >
                Start
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              padding: { xs: theme.spacing(2), md: theme.spacing(6.25) }, // 5rem
              paddingRight: { xs: theme.spacing(2), md: 0 },
              width: { xs: '100%', md: 'auto' },
            }}
          >
            <Box
              component="img"
              src="/static/hero.png"
              alt="hero"
              sx={{
                width: '100%',
                height: 'auto',
                outline: '6px solid',
                outlineColor: 'hsla(220, 25%, 80%, 0.2)',
                boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
                borderRadius: '12px',
                backgroundSize: 'cover',
                display: 'flex',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

